<mmoga-add-to-organization
    [showModal]="showAddToOrganizationModal"
    [organizationSiteDto]="selectedOrganizationSite"
    (organizationAdded)="handleOrganizationAdded($event)">
</mmoga-add-to-organization>

<mmoga-organization-relocation *ngIf="showMoveOrganizationModal"
    [showModal]="showMoveOrganizationModal"
    [currentEnterpriseId]="selectedOrganizationSite?.enterpriseId ?? null"
    [organizationDto]="getSelectedOrganizationDto()"
    (isOrganizationRelocating)="handleOrganizationMoved($event)">
</mmoga-organization-relocation>

<mmoga-preconfigure-migration-modal
    [showModal]="showPreconfigureModal"
    [selectedSiteIds]="selectedSiteIds"
    [isAllSelected]="allPagesSelected"
    [totalItems]="totalItems"
    [activeFilters]="preconfigureFiltersSnapshot"
    [existingPreconfigureDate]="existingPreconfigureDate"
    [existingEnablementDate]="existingEnablementDate"
    [excludedCount]="canSetPreconfigureDate ? preconfigureExcludedCount : 0"
    [canSetPreconfigureDate]="canSetPreconfigureDate"
    [canSetEnablementDate]="canSetEnablementDate"
    (showModalChange)="onBulkActionsModalClose()"
    (bulkActionSaved)="handleBulkActionsSaved($event)">
</mmoga-preconfigure-migration-modal>

<div *ngIf="displaySelectionBanner" class="selection-banner mb-2">
    <div class="alert alert-info d-flex justify-content-between align-items-center mb-0 py-2 px-3 rounded-3">
        <div class="d-flex align-items-center gap-2">
            <span>
                <strong>{{ displayCount }} {{ displayCount === 1 ? 'Site' : 'Sites' }}</strong> Selected.
            </span>
            <button *ngIf="!allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="selectAllInFilter()">
                Select {{ totalItems === 1 ? 'the Site' : 'All ' + totalItems + ' Sites' }} in Current Filter.
            </button>
            <button *ngIf="allPagesSelected" class="btn btn-link fw-semibold p-0" (click)="clearSelection()">
                Deselect {{ totalItems === 1 ? 'the Site' : 'All ' + totalItems + ' Sites' }}.
            </button>
        </div>
        <button class="btn btn-sm btn-outline-primary rounded-pill"
                (click)="openBulkActionsModal()">
            Bulk Actions
        </button>
    </div>
</div>

<p-table data-identifier="organization-site-table"
         [value]="tableData"
         [lazy]="true"
         [lazyLoadOnInit]="false"
         (onLazyLoad)="lazyLoad($event)"
         sortField="name"
         [sortOrder]="1"
         [scrollable]="true">
    <ng-template pTemplate="header">
        <tr *ngIf="totalItems > 0">
            <th [ngStyle]="{'width':'3%'}">
                <input type="checkbox"
                       [checked]="isCurrentPageAllSelected()"
                       (change)="toggleCurrentPage(asCheckbox($event).checked)">
            </th>
            <th class="table-col-7" pSortableColumn="name">Site (URL)
                <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th class="table-col-7" pSortableColumn="globalIdentifier">FGI
                <span class="tooltip-icon pe-1"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Firm Global Identifier">
                    <fa-icon [icon]="faInfoCircle">
                    </fa-icon>
                </span>
                <p-sortIcon field="globalIdentifier"></p-sortIcon>
            </th>
            <th class="table-col-4" pSortableColumn="pod">Pod
                <p-sortIcon field="pod"></p-sortIcon>
            </th>
            <th class="table-col-7" pSortableColumn="enterpriseMemberships.enterprise.name">Organization
                <p-sortIcon field="enterpriseMemberships.enterprise.name"></p-sortIcon>
            </th>
            <th class="table-col-4">Status
            </th>
            <th class="table-col-7">Days in Organization
            </th>
            <th class="table-col-2">Do Not<br><span class="text-nowrap">Auto-migrate</span>
            </th>
            <th class="table-col-5">Preconfigure Date
            </th>
            <th class="table-col-5">Enablement Date
            </th>
            <th class="table-col-1">Actions
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-organization>
        <tr>
            <td>
                <span [title]="organization.enterpriseLoginActive ? fullyEnabledTooltip : ''">
                    <input type="checkbox"
                           [checked]="allPagesSelected || selectedIds.has(organization.id)"
                           [disabled]="!isSelectableForAnyAction(organization)"
                           (change)="toggleRow(organization, asCheckbox($event).checked)">
                </span>
            </td>
            <td>
                <span>{{ organization.organizationName }}</span>
                <span class="text-black-50 ms-1">{{ organization.organizationUrl }}</span>
            </td>
            <td>{{ organization.globalIdentifier }}</td>
            <td>{{ organization.pod | orDash }}</td>
            <td>{{ organization.enterpriseName | orDash}}</td>
            <td>{{ organization.status ? (organization.status | titlecase) : (organization.status | orDash)}}</td>
            <td>{{ organization.daysInEnterprise | orDash }}</td>
            <td>
                <input
                    class="form-check-input"
                    type="checkbox"
                    [disabled]="organization.enterpriseLoginActive"
                    [checked]="organization.migration?.doNotEnable"
                    (change)="onToggleDoNotEnable(organization)"/>
            </td>
            <td>{{ organization.migration?.scheduledPreconfigDate | formatDateArray }}</td>
            <td>{{ organization.migration?.scheduledEnableDate | formatDateArray }}</td>
            <td class="text-nowrap">
                <ng-container *ngIf="organization.status === null; else moveOrganization">
                    <button class="btn btn-sm btn-link text-decoration-none" (click)="openAddToOrganizationModal(organization)">Add to Organization</button>
                </ng-container>
                <ng-template #moveOrganization>
                    <ng-container *ngIf="isRelocationInProgress(organization.id); else moveAction">
                        <button class="btn btn-sm btn-link text-decoration-none" disabled>Relocation in Progress</button>
                    </ng-container>
                    <ng-template #moveAction>
                        <button class="btn btn-sm btn-link text-decoration-none"
                                [disabled]="isMoveDisabled(organization)"
                                (click)="openMoveOrganizationModal(organization)">Move to Organization</button>
                    </ng-template>
                </ng-template>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr data-identifier="no-records">
            <td [attr.colspan]="11">
                <lib-empty-state [message]="'No sites found.'"/>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer">
        <tr data-identifier="table-footer">
            <td [attr.colspan]="11">
                <lib-pagination *ngIf="totalItems > 0"
                                [totalItems]="totalItems"
                                [currentPage]="searchFilter.page"
                                [itemsPerPage]="searchFilter.size"
                                (selectItemsPerPage)="onSelectItemsPerPage($event)"
                                (changeCurrentPage)="onChangeCurrentPage($event)">
                </lib-pagination>
            </td>
        </tr>
    </ng-template>
</p-table>
